import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/.pnpm/next@16.3.3_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@types+node@26.4.1_react-dom@19.2.8_react@19.2.8__react@19.2.8/node_modules/next/dist/client/app-dir/link.js");
